export const CACHE_KEY_SHOW_INFO_SPLASH = "showInfoSplash";
export const CACHE_KEY_ALL_ORDERS = "allOrders";
export const CACHE_KEY_BAR_ID = "barId";
